import { coreAxios } from "@/declare/api/axios"
import { ProjectGroup } from "@/declare/interface/project/project-group"
import { AxiosResponse } from "axios"

/**
 * 创建项目组
 * @param data 项目组
 * @param params 
 * @returns 
 */
export function createProjectGroup(data: ProjectGroup, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/project-groups`, data, {
        params: {
            ...params,
        }
    })
}

/**
 * 查询项目组列表
 * @param params 
 * @returns 
 */
export function findProjectGroups(params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/project-groups`, {
        params: {
            ...params,
        }
    })
}

/**
 * 编辑项目组信息
 * @param uuid 项目组uuid
 * @param data 项目组对象
 * @param params 
 * @returns 
 */
export function updateProjectGroup(uuid: string, data: ProjectGroup, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/project-groups/${uuid}/update`, data, {
        params: {
            ...params,
        }
    })
}

/**
 * 删除项目组
 * @param uuid 项目组uuid
 * @param params 
 * @returns 
 */
export function deleteProjectGroup(uuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/project-groups/${uuid}/delete`, {
        params: {
            ...params,
        }
    })
}
/**
 * 获取项目组详情
 * @param uuid 项目组uuid
 * @returns
 */
export function findProjectGroupDetail(uuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/project-groups/${uuid}`, {
        params: {
            ...params,
        }
    })
}